export const Vote = () => {
  return (
    <svg
      width='14'
      height='8'
      viewBox='0 0 14 8'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 7L7 1L13 7'
        strokeidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const Telegram = () => {
  return (
    <svg
      width='24'
      height='26'
      viewBox='0 0 24 26'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M24 13.2C24 20.0759 18.6274 25.65 12 25.65C5.37258 25.65 0 20.0759 0 13.2C0 6.32405 5.37258 0.75 12 0.75C18.6274 0.75 24 6.32405 24 13.2ZM12.3746 9.74022C11.2103 10.2532 8.88334 11.315 5.39368 12.9256C4.82702 13.1643 4.53017 13.3978 4.50315 13.6261C4.45748 14.012 4.91369 14.164 5.53492 14.3709C5.61942 14.3991 5.70697 14.4282 5.79673 14.4591C6.40793 14.6696 7.23009 14.9158 7.6575 14.9256C8.04521 14.9345 8.47792 14.7651 8.95566 14.4176C12.2162 12.0862 13.8992 10.9078 14.0049 10.8824C14.0794 10.8644 14.1828 10.8419 14.2527 10.9078C14.3227 10.9737 14.3159 11.0985 14.3084 11.132C14.2633 11.3361 12.4725 13.0997 11.5458 14.0123C11.2569 14.2968 11.0519 14.4987 11.01 14.5448C10.9162 14.648 10.8206 14.7457 10.7286 14.8395C10.1608 15.4194 9.73501 15.8542 10.7522 16.5643C11.241 16.9055 11.6322 17.1877 12.0224 17.4692C12.4486 17.7766 12.8737 18.0833 13.4236 18.4652C13.5638 18.5625 13.6976 18.6635 13.8279 18.762C14.3239 19.1365 14.7695 19.473 15.3199 19.4193C15.6398 19.3882 15.9702 19.0695 16.138 18.1193C16.5346 15.8736 17.3141 11.0078 17.4942 9.00269C17.51 8.82702 17.4901 8.60219 17.4742 8.5035C17.4583 8.40481 17.4249 8.26419 17.3038 8.1601C17.1604 8.03682 16.939 8.01082 16.84 8.01258C16.3897 8.02107 15.699 8.27551 12.3746 9.74022Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const Facebook = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM13.1547 11.9991V20H10.0507V11.9994H8.5V9.24221H10.0507V7.58682C10.0507 5.33752 10.9264 4 13.4142 4H15.4853V6.75748H14.1907C13.2223 6.75748 13.1582 7.1428 13.1582 7.86191L13.1547 9.2419H15.5L15.2256 11.9991H13.1547Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const ShareLink = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='currentColor'
        clip-rule='evenodd'
        d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 5.00016C10.0988 5.00016 9.86081 5.0081 9.11414 5.04216C8.36887 5.07623 7.85974 5.19476 7.41454 5.3679C6.94787 5.54336 6.5246 5.8187 6.1746 6.17523C5.81864 6.52483 5.54314 6.94779 5.36727 7.4147C5.19507 7.8599 5.07607 8.3695 5.042 9.11476C5.0084 9.86096 5 10.0985 5 12.0002C5 13.9018 5.00794 14.1394 5.042 14.886C5.07607 15.6313 5.1946 16.1404 5.36774 16.5856C5.5432 17.0523 5.81854 17.4756 6.17507 17.8256C6.52468 18.1815 6.94764 18.457 7.41454 18.6329C7.85974 18.8056 8.36887 18.9241 9.11414 18.9582C9.86081 18.9922 10.0988 19.0002 12 19.0002C13.9012 19.0002 14.1392 18.9922 14.8859 18.9582C15.6311 18.9241 16.1403 18.8056 16.5855 18.6324C17.0521 18.457 17.4754 18.1816 17.8254 17.8251C18.1814 17.4755 18.4569 17.0525 18.6327 16.5856C18.8054 16.1404 18.9239 15.6313 18.958 14.886C18.9921 14.1394 19 13.9014 19 12.0002C19 10.099 18.9921 9.86096 18.958 9.1143C18.9239 8.36903 18.8054 7.8599 18.6323 7.4147C18.4565 6.94759 18.181 6.52445 17.8249 6.17476C17.4753 5.8188 17.0524 5.5433 16.5855 5.36743C16.1403 5.19523 15.6307 5.07623 14.8854 5.04216C14.1392 5.00856 13.9017 5.00016 12 5.00016ZM12 6.26156C13.869 6.26156 14.0907 6.26856 14.8289 6.30216C15.5112 6.33343 15.8817 6.44683 16.1286 6.54343C16.4553 6.6699 16.6886 6.82203 16.9336 7.06656C17.1786 7.31156 17.3303 7.5449 17.4567 7.87156C17.5529 8.11843 17.6667 8.48896 17.698 9.17123C17.7316 9.9095 17.7386 10.1312 17.7386 12.0002C17.7386 13.8692 17.7316 14.0908 17.698 14.8291C17.6667 15.5114 17.5533 15.8819 17.4567 16.1288C17.3447 16.4328 17.1659 16.7079 16.9336 16.9338C16.7078 17.1662 16.4327 17.3449 16.1286 17.4569C15.8817 17.553 15.5112 17.6669 14.8289 17.6982C14.0907 17.7318 13.8695 17.7388 12 17.7388C10.1305 17.7388 9.90934 17.7318 9.17107 17.6982C8.4888 17.6669 8.11827 17.5535 7.87141 17.4569C7.56735 17.3449 7.29227 17.1661 7.0664 16.9338C6.83409 16.7079 6.65533 16.4328 6.54327 16.1288C6.44714 15.8819 6.33327 15.5114 6.302 14.8291C6.2684 14.0908 6.2614 13.8692 6.2614 12.0002C6.2614 10.1312 6.2684 9.9095 6.302 9.17123C6.33327 8.48896 6.44667 8.11843 6.54327 7.87156C6.66974 7.5449 6.82187 7.31156 7.0664 7.06656C7.29224 6.83418 7.56733 6.65542 7.87141 6.54343C8.11827 6.4473 8.4888 6.33343 9.17107 6.30216C9.90934 6.26856 10.131 6.26156 12 6.26156ZM11.1246 14.08C11.3996 14.1957 11.6944 14.2553 11.9921 14.2553C12.5933 14.2553 13.1699 14.0126 13.595 13.5806C14.0202 13.1487 14.259 12.5628 14.259 11.9518C14.259 11.3409 14.0202 10.755 13.595 10.3231C13.1699 9.89107 12.5933 9.64838 11.9921 9.64838C11.6944 9.64838 11.3996 9.70796 11.1246 9.82372C10.8496 9.93948 10.5997 10.1092 10.3892 10.3231C10.1787 10.5369 10.0117 10.7909 9.89777 11.0703C9.78385 11.3498 9.72522 11.6494 9.72522 11.9518C9.72522 12.2543 9.78385 12.5539 9.89777 12.8333C10.0117 13.1128 10.1787 13.3667 10.3892 13.5806C10.5997 13.7945 10.8496 13.9642 11.1246 14.08ZM9.52285 9.44275C10.1777 8.7773 11.066 8.40345 11.9921 8.40345C12.9183 8.40345 13.8065 8.7773 14.4614 9.44275C15.1162 10.1082 15.4841 11.0108 15.4841 11.9518C15.4841 12.8929 15.1162 13.7955 14.4614 14.4609C13.8065 15.1264 12.9183 15.5002 11.9921 15.5002C11.066 15.5002 10.1777 15.1264 9.52285 14.4609C8.86797 13.7955 8.50006 12.8929 8.50006 11.9518C8.50006 11.0108 8.86797 10.1082 9.52285 9.44275ZM16.2583 8.93212C16.4131 8.77482 16.5001 8.56148 16.5001 8.33902C16.5001 8.11656 16.4131 7.90322 16.2583 7.74592C16.1035 7.58861 15.8935 7.50024 15.6746 7.50024C15.4557 7.50024 15.2457 7.58861 15.0909 7.74592C14.9361 7.90322 14.8491 8.11656 14.8491 8.33902C14.8491 8.56148 14.9361 8.77482 15.0909 8.93212C15.2457 9.08942 15.4557 9.17779 15.6746 9.17779C15.8935 9.17779 16.1035 9.08942 16.2583 8.93212Z'
        fill='#BA8D5B'
      />
      <g clip-path='url(#clip0_1397_89257)'>
        <path
          d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
          fill='currentColor'
        />
      </g>
      <path
        className='copy-path'
        d='M13.0293 10.9697C12.4832 10.4238 11.7427 10.1172 10.9706 10.1172C10.1985 10.1172 9.45803 10.4238 8.91195 10.9697L6.85262 13.0283C6.30654 13.5744 5.99976 14.3151 5.99976 15.0873C5.99976 15.8596 6.30654 16.6003 6.85262 17.1463C7.3987 17.6924 8.13935 17.9992 8.91162 17.9992C9.6839 17.9992 10.4245 17.6924 10.9706 17.1463L12 16.117'
        stroke='white'
        strokeidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='copy-path'
        d='M10.9707 13.0295C11.5168 13.5754 12.2573 13.882 13.0294 13.882C13.8015 13.882 14.542 13.5754 15.088 13.0295L17.1474 10.9709C17.6935 10.4248 18.0002 9.68414 18.0002 8.91187C18.0002 8.13959 17.6935 7.39895 17.1474 6.85287C16.6013 6.30678 15.8606 6 15.0884 6C14.3161 6 13.5755 6.30678 13.0294 6.85287L12 7.8822'
        stroke='white'
        strokeidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <clipPath id='clip0_1397_89257'>
          <rect width='24' height='24' fill='currentColor' />
        </clipPath>
      </defs>
    </svg>
  )
};

export const FilterArrow = () => {
  return (
    <svg
      width='12'
      height='8'
      viewBox='0 0 12 8'
      // fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.5 1.75L6 6.25L10.5 1.75'
        strokeidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
